module.exports = __webpack_public_path__ + "img/login-bg.0bfc91b8.jpg";